export const availableShifts = ['04:00-10:00', '10:00-16:00', '16:00-22:00', '22:00-04:00']
